/** @typedef {import('@/types/api').PosPackageCatalogItem} PosPackageCatalogItem */

const PACKAGE_TYPE_LABELS = {
  fixed_combo: 'Fixed combo',
  flexible_combo: 'Flexible combo',
  prepaid_wallet: 'Prepaid wallet',
  membership: 'Membership',
  gift_voucher: 'Gift voucher',
  session_pack: 'Session pack',
}

/**
 * @param {string | null | undefined} type
 */
export function posPackageTypeLabel(type) {
  if (!type) return 'Package'
  return PACKAGE_TYPE_LABELS[type] ?? 'Package'
}

/**
 * @param {PosPackageCatalogItem} pkg
 */
export function posPackagePriceLabel(pkg) {
  const amount = Number(pkg.sale_price)
  if (!Number.isFinite(amount)) return 'AED 0.00'
  return `AED ${amount.toFixed(2)}`
}

/**
 * @param {PosPackageCatalogItem[]} packages
 * @param {string} query
 */
export function filterPosPackages(packages, query) {
  const needle = query.trim().toLowerCase()
  if (!needle) return packages

  return packages.filter((pkg) => {
    const haystack = [
      pkg.name,
      pkg.description,
      pkg.summary,
      posPackageTypeLabel(pkg.type),
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()

    return haystack.includes(needle)
  })
}

/**
 * @param {PosPackageCatalogItem | null | undefined} pkg
 */
export function packageRequiresRecipient(pkg) {
  return Boolean(pkg?.requires_recipient)
}
